import React from 'react';
import { cn } from '@/lib/utils';

interface PollResultMessageProps {
    content: string;
    isOwnMessage?: boolean;
}

// CSS para estilizar o resultado da enquete
const pollResultStyles = `
  .poll-result {
    min-width: 260px;
    font-size: 0.875rem;
  }
  .poll-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }
  .poll-icon {
    font-size: 1.25rem;
  }
  .poll-title {
    font-weight: 600;
    font-size: 0.9375rem;
  }
  .poll-question {
    font-weight: 500;
    margin-bottom: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    background: rgba(139, 92, 246, 0.15);
  }
  .poll-options {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .poll-option {
    padding: 0.375rem 0;
  }
  .poll-option.winner .option-text {
    font-weight: 600;
  }
  .poll-option.winner .option-bar {
    background: linear-gradient(90deg, #f59e0b, #fbbf24) !important;
  }
  .option-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.25rem;
  }
  .option-text {
    flex: 1;
  }
  .option-stats {
    font-size: 0.75rem;
    opacity: 0.8;
    margin-left: 0.5rem;
  }
  .option-bar-bg {
    height: 6px;
    background: rgba(139, 92, 246, 0.2);
    border-radius: 3px;
    overflow: hidden;
  }
  .option-bar {
    height: 100%;
    background: linear-gradient(90deg, #8b5cf6, #a78bfa);
    border-radius: 3px;
    transition: width 0.3s ease;
  }
  .poll-footer {
    margin-top: 0.75rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(139, 92, 246, 0.2);
    font-size: 0.8125rem;
    opacity: 0.9;
  }
`;

export function PollResultMessage({ content, isOwnMessage }: PollResultMessageProps) {
    // Verifica se o conteúdo é HTML (começa com <div)
    const isHtml = content.trim().startsWith('<div');
    
    if (!isHtml) {
        // Fallback para conteúdo de texto antigo
        return (
            <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">
                {content}
            </p>
        );
    }
    
    return (
        <>
            <style>{pollResultStyles}</style>
            <div 
                className={cn(
                    "poll-result-container",
                    isOwnMessage ? "text-white" : "text-inherit"
                )}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </>
    );
}
